import { useEffect, useState } from 'react'
import './styles.scss'
import { IPopupProps } from './types'

export const Popup = ({ content, trigger }: IPopupProps) => {
  const [showContent, setShowContent] = useState(false)

  useEffect(() => {
    document.addEventListener('mousedown', handlerClickOutside)
    return () => document.removeEventListener('mousedown', handlerClickOutside)
  }, [])

  const handlerClickOutside = () => setShowContent(false)

  return (
    <div className="popup" onClick={() => setShowContent(true)}>
      {trigger}

      <span
        className={`popuptext ${showContent ? 'show' : ''}`}
        id="contentPopup"
      >
        {content}
      </span>
    </div>
  )
}
